<template>
  <one-page-layout class="modal">
    <div class="modal__container">
      <button class="modal__close" @click="cancelCallback">
        <img src="../assets/images/close.png" alt="離開" />
      </button>
      <div class="modal__title">{{ title }}</div>
      <div class="modal__text">{{ text }}</div>
      <div class="modal__buttons">
        <button class="sub-button modal__button" @click="cancelCallback">
          {{ cancelText }}
        </button>
        <button class="main-button modal__button" @click="confirmCallback">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </one-page-layout>
</template>

<script>
import OnePageLayout from './OnePageLayout';

export default {
  name: 'AlertModal',
  props: {
    title: {
      type: String,
      default: () => '跳窗標題',
    },
    text: {
      type: String,
      default: () => '跳窗內容',
    },
    confirmCallback: {
      type: Function,
      default: () => () => {},
    },
    cancelCallback: {
      type: Function,
      default: () => () => {},
    },
    cancelText: {
      type: String,
      default: () => '取消',
    },
    confirmText: {
      type: String,
      default: () => '確認',
    },
  },
  components: {
    OnePageLayout,
  },
};
</script>

<style>
.modal {
  position: absolute;
  top: 0;
  z-index: 5;
  background-color: rgba(38, 38, 38, 0.3);
}

.modal__container {
  background-color: #ffffff;
  padding: 40px 24px 26px;
  border-radius: 8px;
  position: relative;
  min-width: 83%;
  box-sizing: border-box;
}
.modal__close {
  background: transparent;
  line-height: 24px;
  width: 24px;
  position: absolute;
  right: 24px;
  top: 16px;
  border: none;
  padding: 0;
}
.modal__title{
  font-weight: 600;
  font-size: 16px;
  color:#262626;
}
.modal__text{
  font-size: 14px;
  color:#595959;
  padding:25px 0 15px;
}
.modal__buttons{
  display: flex;
  justify-content: flex-end;
}
.modal .modal__button{
  padding: 0 16px;
  margin: 4px;
  font-size: 16px;
}
.modal__buttons .sub-button{
  background-color: transparent;
}
</style>
